import type { EnumType } from "~/kernel/enums/EnumType";

export const ImporterType = Object.freeze({
  Custom: "custom",
  Wavy: "wavy",
});

export type ImporterType = EnumType<typeof ImporterType>;
